import styled from 'styled-components'

export const Container = styled.main`
    max-width: ${(props) => props.theme.container.xl};
    margin: 0 auto;
    padding: 0 1.25rem;
`
